import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Price } from '@markant-platform/cartridge/model';
import { TranslocoCurrencyPipe } from '@jsverse/transloco-locale';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'markant-platform-price-comparison',
  standalone: true,
  imports: [CommonModule, TranslocoCurrencyPipe, TranslocoPipe],
  templateUrl: './price-comparison.component.html',
  styleUrl: './price-comparison.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceComparisonComponent {
  @Input({ required: true }) price!: Price;
  @Input() showSetUpCost = false;
}
